import { Injectable } from '@angular/core';
import { HttpClient, HttpXhrBackend, HttpRequest, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { ModelService } from './model.service';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { AlertData } from '../alert/alert-data.entity';

export class RequestOptions {
	public headers?: HttpHeaders;
	public observe?: 'body';
	public params?: HttpParams;
	public reportProgress?: boolean;
	public responseType?: 'json';
	public withCredentials?: boolean;
	public body?: any;

	constructor() {
		this.headers = new HttpHeaders();
	}
}

//class reqHeaders implements IRequestOptions { }

@Injectable({
	providedIn: 'root'
})
export class BearerHttpService {
	//private headerToken: RequestOptions;
	private token = {
		headers: {
			Authorization: 'Bearer ' + this.modelService.getUser().authToken
		}
	}

	constructor(
		private modelService: ModelService,
		public http: HttpClient
		//	_backend?: HttpXhrBackend//	, _defaultOptions?: HttpHeaders // RequestOptions
	) {	//	super(_backend); //, _defaultOptions);
		//var options = null;
		//this.bear(options);
		//this.headerToken.headers.append(options.header);

	}

	// Extending the HttpClient through the Angular DI.
	//public constructor(public http: HttpClient) {
	// If you don't want to use the extended versions in some cases you can access the public property and use the original one.
	// for ex. this.httpClient.http.get(...)
	//}

	//public Get<Response>(url: string, options?:  RequestOptions): Observable<Response> {
	public Get<Response>(url: string): Observable<Response> {
		//		return this.http.get<T>(url, options);
		//this.bear(options);
		if (!this.isTokenValid()) { return; }

		const rq: Observable<Response> = this.http.get<Response>(url, this.token).pipe(share());
		const subs = rq.subscribe(
			(result) => {//const json = JSON.parse(result);
				if (result["token"]) {
					this.modelService.getUser().setAuthToken(result["token"]);
				}
				subs.unsubscribe();
			}, (error) => { console.log('[ERROR get]', error); });
		return rq;
	}

	public Post<Response>(url: string, body: Object, options?: RequestOptions): Observable<Response> {
		//return this.http.post<T>(url, params, options);
		this.bear(options);
		if (!this.isTokenValid()) { return; }

		const rq: Observable<Response> = this.http.post<Response>(url, body, this.token).pipe(share());
		const subs = rq.subscribe(
			(result) => {
				if (result["token"]) {
					this.modelService.getUser().setAuthToken(result["token"]);
				}
				subs.unsubscribe();
			}, (error) => { 
				console.log("ERROR Token Invalid ")
				console.log('[ERROR post]', error); });
		return rq;
	}

	public Put<Response>(url: string, body: Object, options?: RequestOptions): Observable<Response> {
		this.bear(options);
		if (!this.isTokenValid()) { return; }

		const rq: Observable<Response> = this.http.put<Response>(url, body, this.token).pipe(share());
		const subs = rq.subscribe(
			(result) => {
				if (result["token"]) {
					this.modelService.getUser().setAuthToken(result["token"]);
				}
				subs.unsubscribe();
			},
			(error) => { console.log('[ERROR put]', error);	});
		return rq;
	}

	// public Delete<T>(endPoint: string, options?: RequestOptions): Observable<T> { return this.http.delete<T>(endPoint, options); }

	public Delete(endPoint: string): Observable<{}> {
		// Añadir Authorization para evitar error de no autorizado
		const httpOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + this.modelService.getUser().authToken,
			})
		};
		return this.http.delete(endPoint, httpOptions).pipe();
	}

	private bear(options: RequestOptions): RequestOptions {
		// Actualizar Options según documentación angular
		if (options) { options.headers = options.headers;
		} else { options = new RequestOptions(); }

		options.headers.append('Authorization', 'Bearer ' + this.modelService.getUser().authToken);
		return options;
	}

	private isTokenValid(): boolean {
		const expireMS = this.modelService.getUser().sessionExpire * 1000;
		if (expireMS < new Date().getTime()) {
			const data: AlertData = new AlertData();
			data.title = 'Sesion expirado';
			data.message = 'Por favor vuelve a introducir tus datos de usuario.';
			this.modelService.alertSignal.emit(data);
			return false;
		}
		return true;
	}


}


//private launchServerError(error: any, origen: string): void {
//	console.log('[ERROR] ' + origen, error);
	/*
	const data: AlertData = new AlertData();
	data.title = 'Problema de conectividad';
	data.message = error;
	//data.message = 'Por favor, vuelve a iniciar sesión. ';
	//data.message += 'Contacta con soporte si el problema persiste.';
	this.modelService.alert Signal.emit(data);
	*/
//}